// src/components/CustomSection.js
import React from "react";
import "../styles/customsection.css";

const CustomSection = () => {
  return (
    <div className="container custom">
      <div className="custom-card fade-in">
        <div className="custom-left">
          <p className="section-title">Personalizirano do zadnjeg detalja</p>
          <h2 className="section-heading">
            Kreiramo poklon točno za vašu priču.
          </h2>
          <p className="section-subtitle">
            Imate posebnu ideju, tekst ili unutrašnji sadržaj koji biste voljeli
            ugraditi u poklon kutiju? Zatražite potpuno personaliziranu KBIA
            kutiju – od boje, natpisa i dizajna do sitnih detalja unutra.
          </p>

          <ul className="custom-list">
            <li>Personalizirani natpisi, imena i datumi</li>
            <li>Usklađivanje boja s temom vjenčanja ili proslave</li>
            <li>Mogućnost usklađivanja zahvalnica, revera i ostalih detalja</li>
          </ul>

          <button
            className="btn"
            onClick={() => {
              const el = document.getElementById("kontakt");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Zatraži personaliziranu ponudu
          </button>
        </div>

        <div className="custom-right">
          <div className="custom-highlight">
            <span className="custom-highlight-number">1</span>
            <span className="custom-highlight-text">
              ideja — <strong>bezbroj</strong> mogućnosti
            </span>
          </div>
          <div className="custom-info">
            <p>
              Pošaljite nam poruku s nekoliko rečenica o osobi ili događaju za
              koji pripremate poklon. Na temelju toga predlažemo izgled kutije i
              sadržaj koji najbolje odgovara.
            </p>
            <p className="custom-note">
              Sve radimo ručno u maloj radionici u Brodskom Stupniku, uz puno
              pažnje i strpljenja.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomSection;
